import { render } from "./TargetSmart.vue?vue&type=template&id=547e5ca2"
import script from "./TargetSmart.vue?vue&type=script&lang=js"
export * from "./TargetSmart.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__